import React from "react";


export default function ColorGradient({ 
  start = "#000000", 
  middle = "#000000", 
  end = "#000000",
}) {

  return (
    <div 
      className="h-6"
      style={{
        background: `linear-gradient(90deg, ${start} 0%, ${middle} 50%, ${end} 100%)`
      }}
    >
    </div>
  );
}
